/**
 * Variables Globales para Repsol
 */

export const Globals = {
    /*Id Tag D1C*/
    idTagD1C: "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ac56f039dd222f6ca0cedadca0ba4714dde434d10a5a5ef41a14859d1615da051f66bba00339b54244054b7950b01a82913db5292b8958e134ee16afe521492c54d9ace5a3d65b718ee4c99e86ea916d1",
    /*Variables globales D3A whatsapp*/
    D3A: {
        clientId: "1a869709-73bd-40f8-8b5a-7968f0021037",
        campaignId: "11e31bc0-97fb-4221-b44f-03d19d87f767"
    }
}